import type { CoachingCoachCoacheesModel } from '@efdigital/ll-xceed-v2/routes/coaching/coach/coachees';
import Route from '@ember/routing/route';

/**
 * The coachee list itself. The parent route loads the coachees, because a
 * coachee's own page reads the same data.
 */
export default class CoachingCoachCoacheesIndexRoute extends Route<CoachingCoachCoacheesModel> {
  model(): CoachingCoachCoacheesModel {
    return this.modelFor(
      'coaching.coach.coachees'
    ) as CoachingCoachCoacheesModel;
  }
}
